import script from "./RcdTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./RcdTabs.vue?vue&type=script&setup=true&lang=js"

import "./RcdTabs.vue?vue&type=style&index=0&id=533b949f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-533b949f"]])

export default __exports__